/* unplugin-vue-components disabled */import { render } from "./MmPrivacyPolicy.vue?vue&type=template&id=05800852&scoped=true"
import script from "./MmPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./MmPrivacyPolicy.vue?vue&type=script&lang=js"

import "./MmPrivacyPolicy.vue?vue&type=style&index=0&id=05800852&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05800852"]])

export default __exports__